import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { useSelector } from 'react-redux'
import { GetSchedulerReportId, GetSingleMessageData } from '../reportSlices/reportAnalytics'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import ReactApexChart from 'react-apexcharts'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import moment from 'moment-timezone'
import { useGetCampaignReportScheduleDetailsQuery } from '../../../../../services/cellcast'
import { getIsDefaultRegion } from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const Snapshot = () => {
    const navigate = useNavigate()
    const ReportId = useSelector(GetSchedulerReportId)
    const isDefaultRegion = useSelector(getIsDefaultRegion)
    const { data, isFetching } = useGetCampaignReportScheduleDetailsQuery({ campId: ReportId?.id })
    const messageData = data?.data

    let sendData = messageData?.recipients
        ? (+messageData?.deliveredMessage * 100) / +messageData?.recipients
        : 0

    let deliveredData =
        messageData?.deliveredMessage > messageData?.recipients
            ? messageData?.recipients
            : messageData?.deliveredMessage

    if (messageData?.staggerId && messageData?.totalRecipients) {
        sendData = messageData?.totalRecipients
            ? (+deliveredData * 100) / +messageData?.totalRecipients
            : 0
    }

    const bouncedData: any = {
        series: [0, 0, messageData?.recipients],

        options: {
            chart: {
                type: 'donut',
            },
            labels: [
                `Failed      0%)`,
                `Delivered      0%)`,
                `Not sent  0%)`,
            ],
            legend: {
                show: false,
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200,
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
        },
    }

    const calculateResult = (firstNumber: number = 0, secondNumber: number = 0): number =>
        Math.round((100 * secondNumber) / firstNumber) || 0

    const getColor = (value: number = 0) =>
        value < 25 ? '#F53B6E' : value < 70 ? '#FCC419 ' : ' #12B886'

    return (
        <>
            <div className='counted_box_wrapper row'>
                <div className='col-xl-2 col-md-3 col-sm-4 col-6 '>
                    <div
                        className='counted_box circle-progress'
                        style={{
                            cursor: 'pointer',
                        }}
                        onClick={() => navigate('/report-analytics/bulk-messages')}
                    >
                        <div
                            className='box'
                            style={{
                                gap: '0px',
                                marginTop: '10px',
                            }}
                        >
                            <div style={{ width: 100, height: 100 }}>
                                <CircularProgressbar
                                    value={calculateResult(
                                        messageData?.staggerId && messageData?.totalRecipients
                                            ? messageData?.totalRecipients
                                            : messageData?.recipients,
                                        messageData?.recipients
                                    )}
                                    text={`${calculateResult(
                                        messageData?.staggerId && messageData?.totalRecipients
                                            ? messageData?.totalRecipients
                                            : messageData?.recipients,
                                        messageData?.recipients
                                    )}%`}
                                    styles={buildStyles({
                                        textColor: '#3F4254',
                                        pathColor: getColor(
                                            calculateResult(
                                                messageData?.staggerId && messageData?.totalRecipients
                                                    ? messageData?.totalRecipients
                                                    : messageData?.recipients,
                                                messageData?.recipients
                                            )
                                        ),
                                        trailColor: '#EEF6FF',
                                    })}
                                />
                            </div>
                            <div
                                className='title'
                                style={{
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    marginTop: '12px',
                                }}
                            >
                                Contacts
                                <div className='bottom'>
                                    <div className='left'>
                                        ({' '}
                                        {messageData?.staggerId && messageData?.totalRecipients
                                            ? `${messageData?.completedCount > 0 ? messageData?.recipients : 0}/${messageData?.totalRecipients
                                            }`
                                            : messageData?.recipients}
                                        )
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
                    <div
                        className='counted_box circle-progress'
                        style={{
                            cursor: 'pointer',
                        }}
                        // onClick={() => navigate('/eofy/contacts')}
                    >
                        <div
                            className='box'
                            style={{
                                gap: '0px',
                                marginTop: '10px',
                            }}
                        >
                            <div style={{ width: 100, height: 100 }}>
                                <CircularProgressbar
                                    value={calculateResult(
                                        messageData?.staggerId && messageData?.totalRecipients
                                            ? messageData?.totalRecipients
                                            : messageData?.recipients,
                                        deliveredData
                                    )}
                                    text={`${calculateResult(
                                        messageData?.staggerId && messageData?.totalRecipients
                                            ? messageData?.totalRecipients
                                            : messageData?.recipients,
                                        deliveredData
                                    )}%`}
                                    styles={buildStyles({
                                        textColor: '#3F4254',
                                        pathColor: getColor(
                                            calculateResult(
                                                messageData?.staggerId && messageData?.totalRecipients
                                                    ? messageData?.totalRecipients
                                                    : messageData?.recipients,
                                                deliveredData
                                            )
                                        ),
                                        trailColor: '#EEF6FF',
                                    })}
                                />
                            </div>
                            <div
                                className='title'
                                style={{
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    marginTop: '12px',
                                }}
                            >
                                Delivered
                                <div className='bottom'>
                                    <div className='left'>({deliveredData})</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
                    <div
                        className='counted_box circle-progress'
                        style={{
                            cursor: 'pointer',
                        }}
                        // onClick={() => navigate('/eofy/bounced')}
                    >
                        <div
                            className='box'
                            style={{
                                gap: '0px',
                                marginTop: '10px',
                            }}
                        >
                            <div style={{ width: 100, height: 100 }}>
                                <CircularProgressbar
                                    value={calculateResult(messageData?.recipients, messageData?.bouncedMessage)}
                                    text={`${calculateResult(messageData?.recipients, messageData?.bouncedMessage)}%`}
                                    styles={buildStyles({
                                        textColor: '#3F4254',
                                        pathColor: getColor(
                                            calculateResult(messageData?.recipients, messageData?.bouncedMessage)
                                        ),
                                        trailColor: '#EEF6FF',
                                    })}
                                />
                            </div>
                            <div
                                className='title'
                                style={{
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    marginTop: '12px',
                                }}
                            >
                                Failed
                                <div className='bottom'>
                                    <div className='left'>({messageData?.bouncedMessage})</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
                    <div
                        className='counted_box circle-progress'
                        style={{
                            cursor: 'pointer',
                        }}
                        // onClick={() => navigate('/eofy/short_link')}
                    >
                        <div
                            className='box'
                            style={{
                                gap: '0px',
                                marginTop: '10px',
                            }}
                        >
                            <div style={{ width: 100, height: 100 }}>
                                <CircularProgressbar
                                    value={calculateResult(messageData?.recipients, messageData?.clickThrough)}
                                    text={`${calculateResult(messageData?.recipients, messageData?.clickThrough)}%`}
                                    styles={buildStyles({
                                        textColor: '#3F4254',
                                        pathColor: getColor(
                                            calculateResult(messageData?.recipients, messageData?.clickThrough)
                                        ),
                                        trailColor: '#EEF6FF',
                                    })}
                                />
                            </div>
                            <div
                                className='title'
                                style={{
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    marginTop: '12px',
                                }}
                            >
                                Click through
                                <div className='bottom'>
                                    <div className='left'>({messageData?.clickThrough})</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
                    <div
                        className='counted_box circle-progress'
                        style={{
                            cursor: 'pointer',
                        }}
                        // onClick={() => navigate('/eofy/customer_replies')}
                    >
                        <div
                            className='box'
                            style={{
                                gap: '0px',
                                marginTop: '10px',
                            }}
                        >
                            <div style={{ width: 100, height: 100 }}>
                                <CircularProgressbar
                                    value={calculateResult(messageData?.recipients, messageData?.replies)}
                                    text={`${calculateResult(messageData?.recipients, messageData?.replies)}%`}
                                    styles={buildStyles({
                                        textColor: '#3F4254',
                                        pathColor: getColor(
                                            calculateResult(messageData?.recipients, messageData?.replies)
                                        ),
                                        trailColor: '#EEF6FF',
                                    })}
                                />
                            </div>
                            <div
                                className='title'
                                style={{
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    marginTop: '12px',
                                }}
                            >
                                Customer replies
                                <div className='bottom'>
                                    <div className='left'>({messageData?.replies})</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-2 col-md-3 col-sm-4 col-6'>
                    <div
                        className='counted_box circle-progress'
                        style={{
                            cursor: 'pointer',
                        }}
                        // onClick={() => navigate('/eofy/contacts')}
                    >
                        <div
                            className='box'
                            style={{
                                gap: '0px',
                                marginTop: '10px',
                            }}
                        >
                            <div style={{ width: 100, height: 100 }}>
                                <CircularProgressbar
                                    value={calculateResult(messageData?.recipients, messageData?.unsub)}
                                    text={`${calculateResult(messageData?.recipients, messageData?.unsub)}%`}
                                    styles={buildStyles({
                                        textColor: '#3F4254',
                                        pathColor: getColor(
                                            calculateResult(messageData?.recipients, messageData?.unsub)
                                        ),
                                        trailColor: '#EEF6FF',
                                    })}
                                />
                            </div>
                            <div
                                className='title'
                                style={{
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    marginTop: '12px',
                                }}
                            >
                                Unsubscribed
                                <div className='bottom'>
                                    <div className='left'>({messageData?.unsub})</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-xl-4'>
                    <div className='card p-8 py-5 h-100'>
                        <div
                            className='mobile-bg-wrapper grey-bg new_mobile mb-0'
                            style={{
                                backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                            }}
                        >
                            <div className='mobile-inner'>
                                <div className='mobile-head'>
                                    <strong className='msg-mobile-title p-6 d-block text-center px-12'>
                                        <KTSVG
                                            className='svg-icon-8'
                                            path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                                        />
                                        {messageData?.sender}
                                    </strong>
                                </div>

                                <div className='mobile-body'>
                                    <div className='message-box'>
                                        <div className='time text-center'>{moment(messageData?.createdAt).format('LT')}</div>
                                        <div className='message'>
                                            <pre>{messageData?.message}

                                                {(isDefaultRegion && messageData?.replyStopToOptOut) && "Reply 'STOP' to opt-out" }
                                            </pre>
                                        </div>
                                    </div>
                                    <div className='send-msg'>
                                        <input type='text' />
                                        <a
                                            href='#'
                                            className='send_btn'
                                            style={{
                                                backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                                            }}
                                        ></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xl-8'>
                    <div className='card p-8 py-5'>
                        <div className='card-header border-0 p-0 min-h-50'>
                            <h3 className='card-title align-items-start'>
                                <span className='card-label fw-bolder fs-2 mb-1'>Campaign Overview</span>
                            </h3>
                        </div>
                        <div className='card-body px-0 pt-1'>
                            <div className='analytics_charts bounce_chart'>
                                <div className='chart_body'>
                                    <ReactApexChart
                                        options={bouncedData.options}
                                        series={bouncedData.series}
                                        type='donut'
                                        width={450}
                                    />
                                </div>
                                <div className='box_container'>
                                    <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip>Message failed, expired and blocked</Tooltip>}
                                    >
                                        <div className='item'>
                                            <span
                                                className='dot'
                                                style={{
                                                    background: ' rgb(0, 143, 251) ',
                                                }}
                                            ></span>
                                            {`Failed 0%`}
                                        </div>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip>Message delivered to customers mobile</Tooltip>}
                                    >
                                        <div className='item'>
                                            <span
                                                className='dot'
                                                style={{
                                                    background: ' rgb(0, 227, 150) ',
                                                }}
                                            ></span>
                                            {`Delivered 0%`}
                                        </div>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip>Message not delivered to customers mobile</Tooltip>}
                                    >
                                        <div className='item'>
                                            <span
                                                className='dot'
                                                style={{
                                                    background: ' rgb(254, 176, 25) ',
                                                }}
                                            ></span>
                                            {`Not sent 0%`}
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Snapshot
